import { render, staticRenderFns } from "./AddMaira.vue?vue&type=template&id=3e867e9a"
import script from "./AddMaira.vue?vue&type=script&lang=js"
export * from "./AddMaira.vue?vue&type=script&lang=js"
import style0 from "./AddMaira.vue?vue&type=style&index=0&id=3e867e9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports